import { useSelector, useDispatch } from 'react-redux'
import { produce } from 'immer'

import { ApplicationState } from 'src/core/store'
import { Id, Request } from 'src/types'
import { setTicketsEmission } from 'src/core/store/ducks/issuances/actions'

function UpdateETicketCodeRequest({
  requests,
  request_ticket_id,
  value
}: {
  requests: Request
  request_ticket_id: Id
  value: string
}) {
  return produce(requests, draft => {
    draft.request_tickets = draft.request_tickets.map(ticket => {
      if (ticket.request_ticket_id === request_ticket_id) {
        switch (ticket.request_ticket_type) {
          case 'AIR':
            return {
              ...ticket,
              request_ticket_air_selected: {
                ...ticket.request_ticket_air_selected,
                eticket_code: value
              }
            }
          case 'HOTEL':
            return {
              ...ticket,
              request_ticket_hotel_selected: {
                ...ticket.request_ticket_hotel_selected,
                eticket_code: value
              }
            }
          case 'VEHICLE':
            return {
              ...ticket,
              request_ticket_vehicle_selected: {
                ...ticket.request_ticket_vehicle_selected,
                eticket_code: value
              }
            }
          default:
            return ticket
        }
      }
      return ticket
    })
  })
}

// changes the pendinds of all tickets of the chosen type
function useUpdatesPendingIssueTickets(segment: string) {
  const {
    issuances: { ticketsEmission }
  } = useSelector((state: ApplicationState) => ({
    issuances: state.issuances
  }))

  const dispatch = useDispatch()

  const filteredTickets = ticketsEmission.filter(
    ticket => ticket.request_ticket_type === segment
  )

  const isTicketsPending = filteredTickets.some(({ pending }) => pending)

  function handleChange(value: boolean): void {
    dispatch(
      setTicketsEmission(
        ticketsEmission.map(ticket =>
          ticket.request_ticket_type === segment
            ? { ...ticket, pending: value }
            : { ...ticket }
        )
      )
    )
  }

  return { isTicketsPending, handleChange }
}

export { UpdateETicketCodeRequest, useUpdatesPendingIssueTickets }
